import React from 'react';
import PropTypes from 'prop-types';
import styles from './Skeleton.module.scss';

/**
 * Skeleton loader component for showing loading states
 * Matches approximate dimensions of the target element to prevent CLS
 */
const Skeleton = ({
  width = '100%',
  height = '40px',
  borderRadius = '4px',
  className = '',
  variant = 'rectangular' // 'rectangular', 'circular', 'text'
}) => {
  const style = {
    width,
    height,
    borderRadius: variant === 'circular' ? '50%' : borderRadius,
  };

  return (
    <div
      className={`${styles.skeleton} ${styles[variant]} ${className}`}
      style={style}
      aria-busy="true"
      aria-live="polite"
    />
  );
};

Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['rectangular', 'circular', 'text']),
};

export default Skeleton;
